<template>
  <div class="gif-display-popup">
    <div
      class="gif-overlay"
      @click="closeGifs" />

    <div
      ref="gifBoxScroller"
      class="gif-box">

      <div
        v-for="g in gifs"
        :key="g.id"
        class="gif">

        <q-media
          :size="{width: '100%'}"
          :src="g.images.downsized_medium.gif_url"
          :mediaObject="g"
          @click="selectGif" />

      </div>

      <div class="giphy-logo">
        <div>
          <div
            v-if="loading"
            class="loading-gifs giphy-logo">

            <q-icon
              :allowSelfUpdate="false"
              spin
              width="110px"
              name="spinner" />

          </div>
          <div class="giphy-logo text-center">
            <q-image
              class="image-bg"
              name="giphy"
              pack="clear" />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputText from '@/components/standard/input/InputText'
import QImage from '@/components/standard/display/QImage'
import QIcon from '@/components/standard/display/QIcon'
import media from '@/components/standard/display/Media'

export default {
  mounted () {
    let self = this

    // Fetch more gifs on scroll to bottom
    let scroller = this.$refs['gifBoxScroller']
    scroller.onscroll = function() {
      let scrolled = scroller.scrollTop + scroller.clientHeight
      let maxScroll = scroller.scrollHeight

      if (scrolled >= maxScroll - 30) {
        self.$emit('newGifPage', {request: true})
      }
    }
  },
  methods: {
    selectGif (gif) {
      this.$emit('selectGif', {gif: gif})
    },
    closeGifs () {
      this.$emit('closeGifs', {close: true})
    }
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    gifs: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  components: {
    'q-icon': QIcon,
    'q-image': QImage,
    'input-text': InputText,
    'q-media': media
  }

}
</script>

<style scoped>
.image-bg {
  width: 60%!important;
}
.gif-display-popup {
  z-index: 100000;
  position: absolute;
  width: 300px;
  left: 0;
}
.gif-overlay {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  z-index: 100;
}

.gif-box {
  padding: 5px 30px;
  background-color: #ffffff;
  box-shadow: 0 3px 10px rgba(30, 30, 30, 0.429);
  border-radius: 4px;
  width: 100%;
  max-height: 500px;
  overflow-y: scroll;
  z-index: 1000;
  position: absolute;
}
.giphy-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 10px 0;
}
.gif {
  width: 100%;
  margin: 5px;
}

.gif-image {
  float: left;
  border: 1px solid #353635;
  cursor: pointer;
  width: 100%;
}

.card {
  cursor: pointer;
}

@media (max-width: 768px) {
  .gif {
    width: 100%;
  }

  .gif-display-popup {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/standard/display/GifDisplay.vue?1eb79528